module.exports = __webpack_public_path__ + "static/media/arrow-left.ba7a5a15.svg";